import JoinTeamModal from './join-team-modal';
export default JoinTeamModal;